import { Link } from 'react-router-dom';
import { CoinSVG } from '../components/CoinSVG';
import { Button } from '../components/Button';
import { Card } from '../components/Card';

export function NotFound() {
  return <main className="center-page"><Card className="not-found"><div className="lost-coin"><CoinSVG rank={4} side="silver" size={110} /></div><h1>404 — coin out of bounds</h1><p>This space isn’t on the map.</p><Link to="/"><Button>Take me home</Button></Link></Card></main>;
}
